import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { HelpCategory } from './help-category.model';

@Injectable()
export class HelpCategoryService {

  constructor(private http: HttpClient) { }

}
